import Vue from 'vue';
import Layout from './Layout.vue';
import router from './router';
import Vuetify from 'vuetify';
import VueAsyncComputed from 'vue-async-computed';
import Vuep from 'vuep';
import {ResManComponentTracker, ResManUIPlugin, buildVuetifyOptionsFromTheme} from '@resman/ui';
import 'vuetify/dist/vuetify.min.css';
import 'vuep/dist/vuep.css';
import theme from '@resman/ui/themes/base';

Vue.config.productionTip = false;
Vue.use(ResManComponentTracker);
Vue.use(Vuetify);
Vue.use(ResManUIPlugin, {theme});
Vue.use(VueAsyncComputed);
Vue.use(Vuep);

const vuetifyOptions = buildVuetifyOptionsFromTheme({theme});

vuetifyOptions.theme.dark = true;
vuetifyOptions.theme.themes.dark = {
  primary: '#08a7e1',
};

const vuetify = new Vuetify(vuetifyOptions);

new Vue({
  router,
  vuetify,
  render: (h) => h(Layout),
}).$mount('#app');
